import { put, take } from 'redux-saga/effects'

import { SET_CURRENT_PROJECT } from '../actions/currentProject'
import {
  modules,
  programs,
  sensorValues,
  valves,
  search,
} from '../actions/resource'

// Loads all project scoped resources. Used on project switch and after the
// project channel reconnects, when live updates may have been missed.
// fresh: the module list must not reuse a request started before a reconnect.
export function* reloadProjectResources(projectId, { fresh = false } = {}) {
  yield put(programs.list({ projectId }))
  yield put(modules.list(fresh ? { projectId, fresh } : { projectId }))
  yield put(sensorValues.list({ projectId }))
  yield put(valves.list({ projectId }))
  yield put(search.list({ projectId }))
}

export default function* projectSwitchingFlow() {
  while (true) {
    // detect project switch
    const { payload: projectId } = yield take(SET_CURRENT_PROJECT)
    // reload project scoped resources
    yield* reloadProjectResources(projectId)
  }
}
